<template>
  <div class="candidate-table">
    <v-data-table
      :headers="columnsCandidate"
      :items="items"
      item-key="id"
      :page="page"
      @update:page="$emit('update:page', $event)"
      :items-per-page="itemsPerPage"
      class="candidate-table__table"
    >
      <template #item="{ item }">
        <tr class="candidate-table__row" @click="$emit('open', item.id)">
          <td>
            <div class="candidate-table__name-cell">
              <v-icon size="14" class="candidate-table__id-icon">mdi-account-outline</v-icon>
              <span class="candidate-table__name">{{ fullName(item) }}</span>
            </div>
          </td>
          <td>{{ item.Profession }}</td>
          <td>{{ item.Specialization }}</td>
          <td>{{ truncate(item.PhoneNumber, 20) }}</td>
          <td class="candidate-table__email">{{ item.Email }}</td>
          <td class="text-center">
            <v-chip size="x-small" :color="item.CandidateContacted ? 'success' : 'neutral'">
              <v-icon size="13">{{ item.CandidateContacted ? "mdi-check" : "mdi-close" }}</v-icon>
            </v-chip>
          </td>
          <td class="text-center">
            <v-chip size="x-small" :color="item.InterestedInOffers ? 'success' : 'neutral'">
              <v-icon size="13">{{ item.InterestedInOffers ? "mdi-check" : "mdi-close" }}</v-icon>
            </v-chip>
          </td>
          <td class="text-center">
            <v-chip size="x-small" :color="item.HasCV ? 'success' : 'neutral'">
              <v-icon size="13">{{ item.HasCV ? "mdi-file-check-outline" : "mdi-file-remove-outline" }}</v-icon>
            </v-chip>
          </td>
          <td class="candidate-table__nav">
            <v-icon size="18" class="candidate-table__chevron">mdi-chevron-right</v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { defineComponent } from "vue";

// Tabel de candidați în anatomia de board standard (referință: NcrmContractsHome — Table view,
// docs/design.md L71-72): rânduri clickabile (single-click deschide detaliul), nume cu icon pe
// identificatorul primar, status ca metric chips x-small tonale, chevron de navigare la hover în
// loc de coloana „Acțiuni" cu butoane text. Edit/delete rămân în card view + pagina de detaliu.
export default defineComponent({
  name: "CandidateTable",
  props: {
    items: { type: Array, default: () => [] },
    page: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 },
  },
  emits: ["open", "update:page"],
  computed: {
    columnsCandidate() {
      return [
        { key: "LastName", title: this.$t("candidates.table.name") },
        { key: "Profession", title: this.$t("candidates.table.profession") },
        { key: "Specialization", title: this.$t("candidates.table.specialization") },
        { key: "PhoneNumber", title: this.$t("candidates.table.phone"), sortable: false },
        { key: "Email", title: this.$t("candidates.table.email"), sortable: false },
        { key: "CandidateContacted", title: this.$t("candidates.table.contacted"), sortable: false, align: "center" },
        { key: "InterestedInOffers", title: this.$t("candidates.table.interested"), sortable: false, align: "center" },
        { key: "HasCV", title: this.$t("candidates.table.hasCv"), sortable: false, align: "center" },
        { key: "row_nav", title: "", sortable: false, width: 48 },
      ];
    },
  },
  methods: {
    fullName(item) {
      return [item.FirstName, item.LastName].filter(Boolean).join(" ").trim() || "—";
    },
    truncate(text, maxLen) {
      if (!text) return "";
      return text.length > maxLen ? text.slice(0, maxLen) + "..." : text;
    },
  },
});
</script>

<style scoped>
.candidate-table__row {
  cursor: pointer;
}
.candidate-table :deep(th),
.candidate-table :deep(td) {
  text-align: left;
}
.candidate-table :deep(td.text-center),
.candidate-table :deep(th.text-center) {
  text-align: center;
}
.candidate-table__name-cell {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}
.candidate-table__id-icon {
  opacity: 0.55;
  flex-shrink: 0;
}
.candidate-table__name {
  font-weight: 500;
  color: var(--app-text-strong);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.candidate-table__email {
  color: rgba(var(--v-theme-on-surface), 0.72);
}
.candidate-table__nav {
  width: 48px;
  text-align: right;
}
.candidate-table__chevron {
  opacity: 0;
  color: rgba(var(--v-theme-on-surface), 0.38);
  transition: opacity 0.15s ease;
}
.candidate-table__row:hover .candidate-table__chevron {
  opacity: 1;
}
</style>
